export const verificarQtdMaximaDependentesPorPlano = (plano,qtdDependentes) => {
    const qtdDependentesPorPlano = {
        ZE : 14,
        ZF : 14,
        ZT : 14,
        ZS : 14,
        ZSM : 6,
        ZI : 5,
        ZPC : 4,
        ZPET : 3,
        ZPETN : 3
    };

    if (qtdDependentesPorPlano[plano] === qtdDependentes){
        return true;
    }

    return false;
};